import React from 'react';
import * as Style from './style.module.scss';

const SelectableText: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
    children,
    className,
    ...props
}) => {
    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        props.onClick && props.onClick(e);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key !== 'Enter' && e.key !== ' ') {
            return;
        }
        e.preventDefault();
        e.currentTarget.click();
    };

    return (
        <div
            role="button"
            tabIndex={0}
            className={`${Style.selectable} ${className ? className : ''}`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            {...props}
        >
            {children}
        </div>
    );
};

export default SelectableText;
